import React, { useState, useEffect } from 'react';
import { useAuth } from '../../components/Auth/AuthContext';
import { Card, CardContent } from '../../components/ui/card';
import { Heart, Camera } from 'lucide-react';

export default function LikedPhotosSection() {
  const { token } = useAuth();
  const [likedPhotos, setLikedPhotos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLikedPhotos();
  }, []);

  const fetchLikedPhotos = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/user/liked-photos`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const photos = await response.json();
        setLikedPhotos(photos);
      }
    } catch (error) {
      console.error('Error fetching liked photos:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Card>
        <CardContent className="p-6">
          <div className="text-center">Chargement de vos photos likées...</div>
        </CardContent>
      </Card>
    );
  }

  if (likedPhotos.length === 0) {
    return (
      <Card>
        <CardContent className="p-6">
          <div className="text-center py-12">
            <Camera className="h-12 w-12 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-semibold text-gray-600">Aucune photo likée</h3>
            <p className="text-gray-500">
              Explorez les galeries et likez vos photos préférées !
            </p>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold">Photos likées ({likedPhotos.length})</h2>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
        {likedPhotos.map((photoLike, index) => (
          <div key={photoLike.id} className="group relative aspect-square">
            <img
              src={photoLike.photo_url}
              alt="Photo likée"
              className="w-full h-full object-cover rounded-lg"
            />
            
            {/* Overlay on hover */}
            <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity rounded-lg flex items-center justify-center">
              <Heart className="h-6 w-6 text-red-500 fill-current" />
            </div>
            
            {/* Liked date */}
            <div className="absolute bottom-2 left-2 bg-black bg-opacity-70 text-white text-xs px-2 py-1 rounded">
              {new Date(photoLike.liked_at).toLocaleDateString('fr-FR')}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}